import { render, staticRenderFns } from "./sendMessageTab.vue?vue&type=template&id=97a82cc8&scoped=true&lang=pug"
import script from "./sendMessageTab.vue?vue&type=script&lang=js"
export * from "./sendMessageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a82cc8",
  null
  
)

export default component.exports